import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Snackbar from "../../../modules/Snackbar";
import NewFooter from "../../../modules/NewFooter/NewFooter";
import PlanList from "../../../modules/LandingPage/PlanList/PlanList";
import Modal from "../../../shared/Modal/Modal";
import SmsVerificationFormContent from "../../../shared/SmsVerificationFormContent/SmsVerificationFormContent";

import { doLandingSelected } from "../../../../actions/analytics";
import { getMedia } from "../../../../selectors/ui";
import benefitTypes from "../../../../enum/benefitTypes";
import { doFetchPromotions } from "../../../../actions/promotion";

import { rechargeValues } from "../../../../staticFiles/products.json";
import productTVValues from "../../../../staticFiles/productsTV.json";
import { benefits } from "../../../../staticFiles/benefits.json";
import "./index.scss";
import NewHeader from "../../../modules/NewHeader/NewHeader";
import HeaderLanding from "../../../modules/NewHeader/atoms/HeaderLanding";
import { STYLES } from "../../../../styles/_utilities";
import { BannerLanding } from "../../../modules/NewHeader/NewHeader.styles";
import DelayedRender from "../../../shared/DelayedRender/DelayedRender";
import { getBannerConfig } from "../../../../selectors/banner";
import { getChannel } from "../../../../lib/utils";

export const LandingPage = ({ onLandingSelected, media, history }) => {
  const [loginSelected, setLoginSelected] = useState({ type: "default", value: 0 });

  const { showDelayedModal } = history.location.state || {};

  const [delayedModal, setDelayedModal] = useState(showDelayedModal);

  const channel = getChannel();

  const configBanners = getBannerConfig(media, channel);

  const callRechargeValue = rechargeValue => {
    setLoginSelected({ type: "sms", value: rechargeValue.value });
    onLandingSelected(rechargeValue.value / 100, "recharge-value");
  };

  const callProductTVValue = productTVValue => {
    onLandingSelected(productTVValue.plans[0].price / 100, "product-tv-value");
    window.open(process.env.REACT_APP_TV_SCHEDULED_URL, "_blank");
  };

  const callBenefit = benefit => {
    onLandingSelected(benefit.type, "benefit-type");

    if (benefit.type === benefitTypes.NEW_CHIP) {
      window.open(benefits[0].link, "_blank");
      return;
    }
    if (benefit.type === benefitTypes.FLEX) {
      window.open(benefits[3].link, "_blank");
      return;
    }
    if (benefit.type === benefitTypes.PAY) {
      window.open(benefits[2].link, "_blank");
      return;
    }

    const { value } = rechargeValues[1];

    setLoginSelected({ type: "sms", value });
  };

  const closeModal = () => {
    setLoginSelected({ type: "default", value: 0 });
    setDelayedModal(false);
  };

  const contentLoginForm = (
    <>
      <Modal
        width={340}
        height={400}
        contentMargin={5}
        show={loginSelected.type !== "default" || !!delayedModal}
        onClose={closeModal}
      >
        <SmsVerificationFormContent closeModal={closeModal} history={history} />
      </Modal>
    </>
  );

  return (
    <>
      <NewHeader justifyContent={STYLES.contentSpaceBetween}>
        <HeaderLanding />
      </NewHeader>
      <Snackbar />
      <main>
        <BannerLanding
          onClick={() => {
            callRechargeValue(rechargeValues[1]);
          }}
        >
          <BannerLanding.Content src={configBanners.src} alt={configBanners.alt} />
        </BannerLanding>
        <PlanList
          rechargeValues={rechargeValues}
          callRechargeValue={callRechargeValue}
          productTVValues={productTVValues}
          callProductTVValue={callProductTVValue}
          benefits={benefits}
          callBenefit={callBenefit}
          media={media}
          channel={channel}
        />
        {delayedModal ? (
          <DelayedRender delayTime={2000}>{contentLoginForm}</DelayedRender>
        ) : (
          contentLoginForm
        )}
      </main>
      <NewFooter />
    </>
  );
};

LandingPage.propTypes = {
  onLandingSelected: PropTypes.func.isRequired,
  media: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  media: getMedia(state),
});

const mapDispatchToProps = {
  onLandingSelected: doLandingSelected,
  onFetchPromotions: doFetchPromotions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage);
